import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import {  Router } from '@angular/router';
import { HasPermissionDirective } from '../../utils/has-permission.directive';
import { CameraServiceDTO } from '../../models/Camera';
import { CameraService } from '../../services/camera.service';
import { AlertService } from '../shared/alert/alert.service';
import { FullSpinnerService } from '../../services/full-spinner.service';
import { FileUtils } from '../../services/file-util';
import { AppConstants } from '../../utils/AppConstants';

@Component({
  selector: 'app-ts-upload-detail',
  standalone: true,
  imports: [
    CommonModule, 
    HasPermissionDirective, 
    FormsModule, 
    ReactiveFormsModule],
  templateUrl: './ts-upload-detail.component.html',
  styleUrl: './ts-upload-detail.component.scss',
})
export class TsUploadDetailComponent implements OnInit, OnDestroy {

  uploadFile?: File;
  uploadFileName?: string;

  cameraServices: CameraServiceDTO[] = [];
  cameraServiceId?:number;
  constructor(
    private cameraService: CameraService,
    private alertService: AlertService,
    private router: Router,
    private fullSpinnerService: FullSpinnerService) {
    fullSpinnerService.spinner(undefined);
  }
  ngOnInit(): void {
    this.fullSpinnerService.spinner('');
    this.cameraService.findCameraServiceStarted().subscribe({
      next: (res) => {
        this.cameraServices = res;
      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }
  onSubmit(organizationForm: NgForm): void {
    if (organizationForm.valid) {
      this.fullSpinnerService.spinner('');
      this.cameraService.uploadTsFile(this.cameraServiceId!, this.uploadFile!).subscribe({
        next: (_) => {
          this.alertService.addErrors(AppConstants.titleSuccessMessage, [AppConstants.successMessage], true);
          this.cameraServiceId = undefined;
          this.uploadFile = undefined;
          this.router.navigate(['']);
        }, complete: () => {
          this.fullSpinnerService.spinner(undefined);
        }
        , error: () => {
        //  this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }

 
  handleDocumentFileInput(event: any) {
    this.uploadFile = undefined;
    this.uploadFileName = undefined;
    if (event) {
      let retValue = FileUtils.handleFileInput(event, 'application\/x-zip-compressed\/*');
      if (typeof retValue === "number") {
        if (Number(retValue) === -1) {
          this.alertService.addErrors("Errore caricamento", ["Il documento deve essere in formato zip"], true);
          event.target.value = '';
          return;
        }
      }

      this.uploadFile = retValue;
      this.uploadFileName = this.uploadFile?.name;
    }
  }

  ngOnDestroy(): void {
  }
}



